<template lang="html">
  <div class="results__header">
    <div
      v-if="vacancyResults || responseResults || inviteResults"
      class="results__info"
    >
      {{ $tr('searchResults.results.title') }}:
      <span class="results__info_green">
        {{ searchQuery }}
      </span>
    </div>
    <div v-else-if="!searchQuery" class="results__inner results__startSearch">
      <div class="results__iconContainer">
        <i class="fa fa-search results__icon" aria-hidden="true"></i>
      </div>
      {{ $tr('searchResults.startSearch.title') }}
    </div>
    <div
      v-else
      class="results__inner results__noResults"
    >
      <div class="results__iconContainer">
        <i class="fa fa-search results__icon" aria-hidden="true"></i>
      </div>
      <div class="results__noResults-inner">
        {{ $tr('searchResults.noResults.yourSearch') }}
        <span class="results__info_green">
          "{{ searchQuery }}"
        </span>
        {{ $tr('searchResults.noResults.didNotMatch') }}
        <br/>
        {{ $tr('searchResults.noResults.useMore') }}
        <span class="results__info_green results__info_underline">
          {{ $tr('searchResults.noResults.example.manager') }}
        </span>,
        <span class="results__info_green results__info_underline">
          {{ $tr('searchResults.noResults.example.specialist') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SearchStart',

    props: {
      vacancyResults: {
        type: Boolean,
        default: false
      },

      responseResults: {
        type: Boolean,
        default: false
      },

      inviteResults: {
        type: Boolean,
        default: true
      },

      searchQuery: {
        type: String,
        default: ''
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .results {
    &__header {
      margin-bottom: 20px;
    }

    &__info {
      font-size: 24px;
      color: #b7b7b7;
      user-select: none;
      cursor: default;

      &_green {
        color: $green;
        cursor: default;
      }

      &_underline {
        text-decoration: underline !important;
      }
    }

    &__inner {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 70px;
    }

    &__startSearch {
      font-size: 18px;
    }

    &__noResults {
      font-size: 18px;
    }

    &__iconContainer {
      border: 3px solid $green;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 30px;
    }

    &__icon {
      font-size: 45px !important;
      color: $green;
    }
  }
</style>
